import { supabase } from '@/integrations/supabase/client';

export type TierKey = 'starter' | 'growth' | 'pro';
export type IntervalKey = 'month' | 'year';

export interface CheckoutResult {
  ok: boolean;
  error?: string;
}

/**
 * Starts a Stripe Checkout session and redirects the browser to it.
 * Shared by the pricing page, the setup wizard and the trial banners so
 * every upgrade path behaves the same way.
 */
export const startCheckout = async (
  tier: TierKey,
  units: number,
  interval: IntervalKey
): Promise<CheckoutResult> => {
  if (units < 1) return { ok: false, error: 'Please choose at least one location.' };

  const { data: sessionData } = await supabase.auth.getSession();
  if (!sessionData.session) {
    window.location.href = '/auth?redirect=/pricing';
    return { ok: false, error: 'Please sign in first.' };
  }

  try {
    const { data, error } = await supabase.functions.invoke('checkout', {
      body: { tier, units, interval },
    });

    if (error) return { ok: false, error: error.message || 'Could not start checkout.' };
    if (data?.error) return { ok: false, error: data.details || data.error };
    if (data?.url) {
      window.location.href = data.url;
      return { ok: true };
    }
    return { ok: false, error: 'Could not start checkout.' };
  } catch {
    return { ok: false, error: 'Could not start checkout. Please try again.' };
  }
};
